import React, { useContext, useEffect } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ApplicantProfileTabs from "../Contents/ApplicantProfile/ApplicantProfileTabs";
import { Button, IconButton, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import Tooltip from '@mui/material/Tooltip';
import { useState } from "react";
import { ContextData } from "../../../context/Context";
import { Getrequest, Putrequest } from "../../../context/AxiosRequest";
import { toast } from "react-toastify";
import SoundAlert from "../../../routes/SoundAlert";
import BankStatusListDialogue from "./bank/BankStatusListDialogue";
import OfferLoader from "./bank/OfferLoader";

function Bankreviewer({type,name,params}) {


  const [searchText, setSearchText] = useState("");
  const {accesstoken,GlobalLoader,setGlobalLoader,Allow,UserTokens} = useContext(ContextData)
  const [ApplicantData,setApplicantData] = React.useState(null)
  const [GetToken,setGetToken] = React.useState()




       const GetChangeLoanForm = ({ user_token }) => {

            const [ChangeLoanForm, setChangeLoanForm] = useState("");

            useEffect(() => {
              let isMounted = true;

              async function fetchLoanForm() {
                const loanData = await Getrequest(`/auth/get_loan_data/${user_token}`, accesstoken);
                if (isMounted && loanData) {
                  setChangeLoanForm(loanData?.loanrequest?.[0]?.loan_category || "");
                }
              }

              if (user_token) {
                fetchLoanForm();
              }

              return () => {
                isMounted = false;
              };
            }, [user_token, accesstoken]);

             if (ChangeLoanForm === ""){

                  return <><span>Loading...</span></>
             } 

            return (
              <>
                <span>
                  {ChangeLoanForm === "studentloan" ? <span className="bg-pink-800 p-2 text-white">Student Loan</span> : <span className="bg-blue-950 p-2 text-white">ThirdParty Loan</span>}
                </span>
              </>
            );


       }

       
      const GetApplicant = (user_token)=>{
  
       setGetToken(user_token)

      }
  
      React.useEffect(()=>{
  
                    async function FetchData() {
                         const response = await Getrequest(`auth/get_applicantBio_for_qualification_type/${params === undefined ? "bank" : params.trim() }/bank`,accesstoken)
                         const uniqueApplicants = Array.from(new Set(response.map(item => JSON.stringify(item)))).map(item => JSON.parse(item))
                          setApplicantData(uniqueApplicants)
                    }
     
                  FetchData()
      },[GlobalLoader])

      

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };


  const HandleVerify = async (user_token,type) => {


     /*  if(!Allow) {

          toast.warn("Applicant documents need verification")
          SoundAlert("error")
          return
      } */


    const data = {
      user_token,
      type,
      verifier_token: UserTokens
    };

    const response = await Putrequest( `auth/handle_verify_done_return`,data,accesstoken);
    
       if(response.status){

          toast.success(response.textStatus);
      setGlobalLoader(!GlobalLoader)
      SoundAlert("success")
       }else{

      toast.warn(response.textStatus);
      setGlobalLoader(!GlobalLoader)
      SoundAlert("success")

       }
     

  }

  const [DataValue, setDataValue] = useState("loan");
  
  const handleChange = (event) => {
    setDataValue(event.target.value);
  };


  
  return (
    <div className="h-[92vh] p-6 overflow-x-hidden">

      <h1 className="font-bold text-2xl"> {name !== undefined ? name : "Bank Reviewer"} </h1>
 

          {
            type !== "BankStatusListDialogue" &&
        <div className="flex justify-center items-center mb-4 mt-4 gap-4">
          <p className="whitespace-nowrap">Select Application Type:</p>
            <select
        onChange={handleChange}
        value={DataValue}
        className="w-full p-2 rounded-md bg-[#030323e6] text-white font-bold"
      >
        <option value="loan">Loan Applications</option>
      </select>
        </div>
          }
          
          {
          type !== "BankStatusListDialogue" &&
          <div className="flex flex-row">
          <BankStatusListDialogue
            type= "rejected"
            Bgcolor=""
            name="Rejected Applications"
            
          />
          <BankStatusListDialogue
            type="accepted"
            Bgcolor="green"
            name="Accepted Applications"
          />
  
           <BankStatusListDialogue
            type="Ready For DISBURSEMENT"
            Bgcolor="blue"
            name="Ready For DISBURSEMENT"
          />

            <BankStatusListDialogue
            type="DISBURSEMENT DONE"
            Bgcolor="purple"
            name="DISBURSEMENT DONE"
          />

        
          </div>
          }
          
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <div className=" d-flex items-start h-[100%]  ">
        <div
          style={{ height: "100%" }}
          className="verification-aside w-1/3 bg-slate-100 overflow-auto border-r-2 border-black border-solid"
        > 
          
          <ul className="ver-aside-ul mb-28">
            {ApplicantData !== null && ApplicantData.map((item, index) => (
              <Tooltip title={type === "accepted" && item.verify_status === "accepted" ? "Waiting for this Applicant to Accept the Offer" : `${item.fname} ${item.lname}`} placement="right">
             <li className={`flex justify-between whitespace-nowrap   items-center ${item.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(item.user_token)}  key={index}>
                <span>
                  
                <span className="pl-1 pr-1">{index + 1}.</span>
                <AccountCircleIcon /> {`${item.fname}`}
                </span>
              
                 {
                  item.verify_status !== "approved" ?
                   <>

                   <GetChangeLoanForm user_token={item.user_token} />  
                   {
                    (item.agreed_sign === "agreed" && item.agreed_g === "agreed" ) &&
 
                    <span className="bg-green-900 text-white p-1">Agreed & Signed</span>
                   }
                   
                   </>
                  :
                <span className="flex pr-2">
                  <Button onClick={()=>HandleVerify(item.user_token,"rejected")} variant="contained" sx={{background:"darkred",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Reject</Button>
                   {/* <Button onClick={()=>HandleVerify(item.user_token,"notok")} variant="contained" sx={{background:"white",marginRight:"4px",color:"black"}} disabled={item.user_token !== GetToken }>Not Okay</Button> */}
                  <Button onClick={()=>HandleVerify(item.user_token,"accepted")} variant="contained" disabled={item.user_token !== GetToken }>Accept</Button>
                </span>
                 }
              
              </li> 
          </Tooltip>  
              
            ))}
          </ul> 
        </div>

        <div style={{ height: "100%", width:"100%" }} className="overflow-auto mb-40">
          <ApplicantProfileTabs sty="sty" typeForUser={params} applicationType={DataValue} usertoken={GetToken} from="bankreviewer" />
        </div>
      </div>
    </div>
  );
}

export default Bankreviewer;
